/**
 * External dependencies
 */
import { __ } from '@web-stories-wp/i18n';

/**
 * Internal dependencies
 */
import type { LottieElement } from '../types';

function getLottieLayerText(element: LottieElement) {
  return element.title || __('Lottie animation', 'web-stories');
}

export default getLottieLayerText;
